/*eslint-disable*/
export default navbar => {
	let $navbar = $(navbar)
	let initialScrollPos = window.pageYOffset
	let currentScrollPos = initialScrollPos
	let subnav = navbar.querySelector('.js-sub-nav')
	let $subnav = $(subnav)
	let registry;
	let $mobileNav = $('.js-mobile-nav')
	if($('#wrapper').hasClass('is-registry')){
		registry = true
		$mobileNav.addClass('registry')
	}
	else {
		registry = null;
		$mobileNav.removeClass('registry')
	}
		 
	$(window).on('load scroll', (e) => {
		if ($('.hide-scroll-mobile').length && window.matchMedia("(max-width: 1180px)").matches) {
			currentScrollPos = window.pageYOffset
			addScrollListener()
		}
		else if ($('.hide-scroll-desktop').length && window.matchMedia("(min-width: 1181px)").matches) {
			currentScrollPos = window.pageYOffset
			addScrollListener()
		}
		else if ($('.hide-scroll-full').length ){
			currentScrollPos = window.pageYOffset
			addScrollListener()
		}
	})

	const addScrollListener = () => {
		if (currentScrollPos < 300) {
			$navbar.addClass('sub-nav-showing')
			$mobileNav.addClass('nav-open')
			$subnav.hasClass('hhh-header-wrapper') && $subnav.addClass('nav-open top')
			registry && $navbar.find('.registry__block').css('border-top', 'border-top: 1px solid #E7E7E7;')
		}
		if (currentScrollPos < initialScrollPos) {
			$navbar.addClass('sub-nav-showing')
			$mobileNav.addClass('nav-open')
			$subnav.hasClass('hhh-header-wrapper') && $subnav.addClass('nav-open')
			registry && $navbar.find('.registry__block').css('border-top', 'border-top: 1px solid #E7E7E7;')
			initialScrollPos = currentScrollPos
		}
		else if (currentScrollPos > initialScrollPos + 300) {
			initialScrollPos = currentScrollPos
			$navbar.removeClass('sub-nav-showing')
			$mobileNav.removeClass('nav-open')
			$subnav.hasClass('hhh-header-wrapper') && $subnav.removeClass('nav-open top')
			registry && $navbar.find('.registry__block').css('border-top', '')
		}
	}
}


// WEBPACK FOOTER //
// ./src/scripts/components/hide-nav-scroll.js